export default "__VITE_ASSET__BOILf$Zh__"